// ----- SHARED CART HELPERS (Nx-style) -----
function nxUpdateCartCount() {
  fetch('/')
    .then((response) => response.text())
    .then((html) => {
      var temp = document.createElement('div');
      temp.innerHTML = html;

      // This theme has multiple `id="cart-icon-bubble"` nodes (desktop/mobile/announcement).
      // Keep them all in sync.
      var newBubbles = temp.querySelectorAll('#cart-icon-bubble');
      var oldBubbles = document.querySelectorAll('#cart-icon-bubble');

      if (newBubbles && newBubbles.length && oldBubbles && oldBubbles.length) {
        oldBubbles.forEach(function (oldBubble, idx) {
          var newBubble = newBubbles[idx] || newBubbles[0];
          if (!newBubble || !oldBubble) return;
          oldBubble.innerHTML = newBubble.innerHTML;
        });
      }
    })
    .catch((e) => console.error('nxUpdateCartCount error', e));
}

function nxUpdateCartTotals(cart) {
  if (!cart) return;

  var totalPrice = cart.total_price; // cents
  // simple fallback formatter – replace with themeCurrency.formatMoney if you have it
  var formatted =
    typeof themeCurrency !== 'undefined' && theme && theme.moneyFormat
      ? themeCurrency.formatMoney(totalPrice, theme.moneyFormat)
      : (totalPrice / 100).toFixed(2);

  document.querySelectorAll('.cst-cart-total').forEach(function (el) {
    if (!el) return;
    el.innerHTML = formatted + ' Inc. VAT';
  });
}

function nxFetchCartAndUpdateUI() {
  return fetch('/cart.js')
    .then((r) => r.json())
    .then((cart) => {
      nxUpdateCartTotals(cart);
      nxUpdateCartCount();
      return cart;
    })
    .catch((e) => console.error('nxFetchCartAndUpdateUI error', e));
}


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // 🔹 Only redirect when there is NO cart element and NOT bg_update
            if (!this.cart && this.dataset.cartType !== 'bg_update') {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');

            // 🔹 If there IS a cart drawer/notification, keep the normal behavior
            if (this.cart) {
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure('add:paint-updated-sections', () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              }
            }

            if (!this.cart && this.dataset.cartType === 'bg_update') {
              nxFetchCartAndUpdateUI();
            }

          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
